export default {
    filter: 'Фильтр',
    fields: {
        date_from: {
            label: 'От даты',
            placeholder: 'Выберите дату',
            tool_tip_message: 'Начальная дата расписания',
        },
        date_to: {
            label: 'До даты',
            placeholder: 'Выберите дату',
            tool_tip_message: 'Конечная дата расписания',
        },
        status: {
            label: 'Статус',
            placeholder: 'Выберите статус',
        },
        order_by: {
            label: 'Сортировать по',
            placeholder: 'Выберите сортировку',
        },
        user: {
            label: 'Пользователь',
            placeholder: 'Enter Пользователь',
        },
        company: {
            label: 'Компания',
            placeholder: 'Enter Компания',
        },
        year: {
            label: 'Год',
            placeholder: 'Выберите год',
        },
        location: {
            label: 'Все локации',
            placeholder: 'Все локации',
        },
    },
    sort: {
        sort: 'Сортировка',
        createdAt_ASC: 'Дата создания - по возрастанию',
        createdAt_DESC: 'Дата создания - по убыванию',
        updatedAt_ASC: 'Дата обновления - последняя',
        updatedAt_DESC: 'Дата обновления - старая',
        reservationTime_ASC: 'Назначено на - старые',
        reservationTime_DESC: 'Назначено на - последние',
        firstName_ASC: 'Имя - Растуче',
        firstName_DESC: 'Имя - Опадаюче',
        lastName_ASC: 'Предложение - Растуче',
        lastName_DESC: 'Предложение - Опадаюче',
    },
}
